import type { TenantConfig } from "@/types/tenantFeatures";
import { apiGet } from "@/services/genesisApi/httpsMethods";

/** Some APIs wrap the payload in { data: ... }. */
function normalizeTenantConfig(body: unknown): TenantConfig | null {
  if (!body || typeof body !== "object") {
    return null;
  }
  const record = body as Record<string, unknown>;
  let raw: Record<string, unknown> | null = null;
  if (typeof record.tenant_key === "string") {
    raw = record;
  } else if (record.data && typeof record.data === "object") {
    const inner = record.data as Record<string, unknown>;
    if (typeof inner.tenant_key === "string") {
      raw = inner;
    }
  }
  if (!raw) {
    return null;
  }

  const config = raw as unknown as TenantConfig;
  return {
    ...config,
    prompt_admin_enabled: config.prompt_admin_enabled === true,
    is_prompt_admin: config.is_prompt_admin === true,
  };
}

export async function fetchTenantFeatures() {
  const response = await apiGet<unknown>("tenant/features");
  if (!response.success || !response.data) {
    return { ...response, data: null as TenantConfig | null };
  }
  const config = normalizeTenantConfig(response.data);
  if (!config) {
    return {
      success: false,
      status: response.status,
      message: "Invalid tenant/features response",
      data: null,
    };
  }
  return { ...response, data: config };
}
